<template>
  <div>
    <div>
      <sidebar />
      <div class="relative md:ml-56 bg-blueGray-100 min-h-screen">
        <admin-navbar />
        <div class="px-4 md:px-10 mx-auto w-full md:-mt-24 pb-20">
          <router-view />
        </div>
        <footer-admin />
      </div>
    </div>
    <div
      v-if="
        componentLoading || productLoading || categoryLoading['mainLoading']
      "
      class="fixed inset-0 z-100 bg-gray-900 bg-opacity-90 flex justify-center items-center"
    >
      <LoadingPage :loadings="loadings" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Helpers from "@/helpers";
import * as Actions from "@/store/actions.type";
import AdminNavbar from "@/components/Shared/Navbars/AdminNavbar.vue";
import Sidebar from "@/components/Shared/Sidebar/Sidebar.vue";
import FooterAdmin from "@/components/Shared/Footers/FooterAdmin.vue";
import LoadingPage from "@/components/Shared/Loading/LoadingPage.vue";

export default {
  name: "admin-layout",
  components: {
    AdminNavbar,
    Sidebar,
    FooterAdmin,
    LoadingPage
  },
  created() {
    if (localStorage.getItem("cm_region")) {
      this.$store.dispatch(
        Actions.SET_REGION,
        localStorage.getItem("cm_region")
      );
    }
  },
  mounted() {
    Helpers.loadAllRelatedData(this, {
      hardRefresh: false,
      region: this.getRegion
    });
  },
  computed: {
    loadings() {
      return [
        {
          name: "componentLoading",
          value: this.componentLoading,
          message: `Mission accomplished: Components secured! ✅ Time to assemble the mothership! 🛸`
        },
        {
          name: "productLoading",
          value: this.productLoading,
          message: `Level up! Products unlocked! 🎮✨ The galactic marketplace is now open! 🚀`
        },
        {
          name: "categoryLoading",
          value: this.categoryLoading["mainLoading"],
          message: `Categories summoned into existence! 🔮 Space-time continuum stabilized! 🌌`
        }
      ];
    },
    ...mapGetters([
      "componentLoading",
      "productLoading",
      "categoryLoading",
      "getRegion"
    ])
  }
};
</script>
